<div *ngIf="showLoadingIndicatior" class="page-loader-wrapper">
  <div class="loader">
    <div class="m-t-30">
      <img class="loading-img-spin" src="assets/images/loading.png" width="20" height="20" alt="admin">
    </div>
    <p>Please wait...</p>
  </div>
</div>
<div class="overlay"></div>
<!-- #END# Overlay For Sidebars -->
<!-- Search Bar -->
<div id="main-component">
  <nav class="navbar">
    <div class="container-fluid">
      <div class="navbar-header" id="leftsidebar-logo-area">
        <a href="#" onClick="return false;" class="navbar-toggle collapsed" data-toggle="collapse"
          data-target="#navbar-collapse" aria-expanded="false"></a>
        <a href="#" onClick="return false;" class="bars"></a>
        <a class="navbar-brand" routerLink="dashboard/main">
          <!-- <img src="assets/images/aavin_log.jpeg" style="width: 35%;" alt="" />-->
          <span id="logo-text">Covai Aavin</span>
        </a>
      </div>
      <div class="collapse navbar-collapse" id="navbar-collapse">
        <ul class="pull-left">
          <li>
            <a href="#" onClick="return false;" class="sidemenu-collapse">
              <i class="material-icons">reorder</i>
            </a>
          </li>
        </ul>
        <!-- <ul class="nav navbar-nav navbar-right">
          <li class="fullscreen">
            <a href="javascript:;" class="fullscreen-btn">
              <i class="fas fa-expand"></i>
            </a>
          </li>
          <li class="dropdown">
            <a href="#" onClick="return false;" class="dropdown-toggle" data-toggle="dropdown" role="button">
              <i class="far fa-bell"></i>
              <span class="label-count bg-orange"></span>
            </a>
            <ul class="dropdown-menu pullDown">
              <li class="header">NOTIFICATIONS</li>
              <li class="body">
                <ul class="menu">
                  <li>
                    <a href="#" onClick="return false;">
                      <span class="table-img msg-user">
                        <img src="assets/images/user/user1.jpg" alt="">
                      </span>
                      <span class="menu-info">
                        <span class="menu-title">Sarah Smith</span>
                        <span class="menu-desc">
                          <i class="material-icons">access_time</i> 14 mins ago
                        </span>
                        <span class="menu-desc">Please check your email.</span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick="return false;">
                      <span class="table-img msg-user">
                        <img src="assets/images/user/user2.jpg" alt="">
                      </span>
                      <span class="menu-info">
                        <span class="menu-title">Airi Satou</span>
                        <span class="menu-desc">
                          <i class="material-icons">access_time</i> 22 mins ago
                        </span>
                        <span class="menu-desc">Please check your email.</span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick="return false;">
                      <span class="table-img msg-user">
                        <img src="assets/images/user/user3.jpg" alt="">
                      </span>
                      <span class="menu-info">
                        <span class="menu-title">John Doe</span>
                        <span class="menu-desc">
                          <i class="material-icons">access_time</i> 3 hours ago
                        </span>
                        <span class="menu-desc">Please check your email.</span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick="return false;">
                      <span class="table-img msg-user">
                        <img src="assets/images/user/user4.jpg" alt="">
                      </span>
                      <span class="menu-info">
                        <span class="menu-title">Ashton Cox</span>
                        <span class="menu-desc">
                          <i class="material-icons">access_time</i> 2 hours ago
                        </span>
                        <span class="menu-desc">Please check your email.</span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick="return false;">
                      <span class="table-img msg-user">
                        <img src="assets/images/user/user5.jpg" alt="">
                      </span>
                      <span class="menu-info">
                        <span class="menu-title">Cara Stevens</span>
                        <span class="menu-desc">
                          <i class="material-icons">access_time</i> 4 hours ago
                        </span>
                        <span class="menu-desc">Please check your email.</span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick="return false;">
                      <span class="table-img msg-user">
                        <img src="assets/images/user/user6.jpg" alt="">
                      </span>
                      <span class="menu-info">
                        <span class="menu-title">Charde Marshall</span>
                        <span class="menu-desc">
                          <i class="material-icons">access_time</i> 3 hours ago
                        </span>
                        <span class="menu-desc">Please check your email.</span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick="return false;">
                      <span class="table-img msg-user">
                        <img src="assets/images/user/user7.jpg" alt="">
                      </span>
                      <span class="menu-info">
                        <span class="menu-title">John Doe</span>
                        <span class="menu-desc">
                          <i class="material-icons">access_time</i> Yesterday
                        </span>
                        <span class="menu-desc">Please check your email.</span>
                      </span>
                    </a>
                  </li>
                </ul>
              </li>
              <li class="footer">
                <a href="#" onClick="return false;">View All Notifications</a>
              </li>
            </ul>
          </li>
          <li class="dropdown user_profile">
            <a href="#" onClick="return false;" class="dropdown-toggle" data-toggle="dropdown" role="button">
              <img src="assets/images/user.jpg" width="32" height="32" alt="User">
            </a>
            <ul class="dropdown-menu pullDown">
              <li class="body">
                <ul class="user_dw_menu">
                  <li>
                    <a href="#" onClick="return false;">
                      <i class="material-icons">person</i>Profile
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick="return false;">
                      <i class="material-icons">feedback</i>Feedback
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick="return false;">
                      <i class="material-icons">help</i>Help
                    </a>
                  </li>
                  <li>
                    <a (click)="logOut()">
                      <i class="material-icons">power_settings_new</i>Logout
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li class="pull-right">
            <a href="#" onClick="return false;" class="js-right-sidebar" data-close="true">
              <i class="fas fa-cog"></i>
            </a>
          </li>
        </ul> -->
        <!-- class=" " -->
        <button mat-button class="button-class navbar-right nav navbar-nav"
          style="margin-top: 1%;margin-right: 2%; font-size: 19px;" (click)="logOut()"> <span class="material-icons">
            power_settings_new
          </span> Logout</button>
      </div>
    </div>
  </nav>
  <div>
    <!-- Left Sidebar -->
    <aside id="leftsidebar" class="sidebar">
      <!-- Menu -->
      <div class="menu">
        <ul class="list">
          <li class="sidebar-user-panel">
            <div class="user-panel">
              <div class=" image">
                <span *ngIf="global._user_image == 'no-image'">
                  <img src="assets/images/dummy_user.jpg" class="img-circle user-img-circle" alt="User Image" />
                </span>
                <span *ngIf="global._user_image != 'no-image'">
                  <img [src]="global._user_image" style="margin-left: 4px;" class="img-circle user-img-circle"
                    alt="User Image" />
                </span>
              </div>
            </div>
            <div class="profile-usertitle">
              <div class="sidebar-userpic-name" style="font-size: 16px;"> {{ global._active_user }} </div>
              <div class="profile-usertitle-job" style="font-size: 16px;"> {{global._user_position}} </div>
            </div>
          </li>

          <li routerLinkActive="active" [ngClass]="selected_header_id === header['id']? 'selected-header': ''"
            *ngFor="let header of headers">
            <a (click)="toggleHeader(header['id'])" class="menu-toggle">
              <i class="{{header['icon']}}"></i>
              <span style="color: white">{{header['display_name']}}</span>
            </a>

            <ul class="ml-menu" [ngStyle]="{display: isShowPage(header['id'])}">
              <li routerLinkActive="active" [ngClass]="selected_page_id === page['id']? 'selected-page': 'non-selected-page'"
                *ngFor="let page of pages[header['id']]" (click)="navPage(page['link'], page['id'], page['display_name'])">
                <a [ngClass]="selected_page_id === page['id']? 'selected-page-active': 'selected-page-inactive'">{{page['display_name']}}</a>
              </li>
            </ul>
          </li>
<!--uncomment this to activate second style of menu-->
<!--          <mat-accordion>-->
<!--            <mat-expansion-panel (opened)="toggleHeader(header['id'])" [ngClass]="selected_header_id === header['id']? 'selected-header': ''" style="padding: 0; margin: 0;" *ngFor="let header of headers">-->
<!--              <mat-expansion-panel-header>-->
<!--                <mat-panel-title>-->
<!--                  <mat-icon>toc</mat-icon>{{header['display_name']}}-->
<!--                </mat-panel-title>-->
<!--              </mat-expansion-panel-header>-->

<!--              &lt;!&ndash; <ul class="ml-menu" [ngStyle]="{display: isShowPage(header['id'])}"> &ndash;&gt;-->
<!--                <li routerLinkActive="active" [ngClass]="selected_page_id === page['id']? 'selected-page': ''"-->
<!--                  *ngFor="let page of pages[header['id']]" (click)="navPage(page['link'], page['id'])">-->
<!--                  &lt;!&ndash; <li routerLinkActive="active" [ngStyle]="{'background-color': selected_page_id === page['id']? 'green': ''}" *ngFor="let page of pages[header['id']]" (click)="navPage(page['link'], page['id'])"> &ndash;&gt;-->
<!--                  <a>{{page['display_name']}}</a>-->
<!--                </li>-->
<!--              &lt;!&ndash; </ul> &ndash;&gt;-->
<!--            </mat-expansion-panel>-->
<!--          </mat-accordion>-->


          <!-- <mat-expansion-panel [ngClass]="selected_header_id === header['id']? 'selected-header': ''"
          *ngFor="let header of headers">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{header['display_name']}}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <mat-form-field>
              <mat-label>Country</mat-label>
            </mat-form-field>
          </mat-expansion-panel> -->
<!--          <div>Before dynamic</div>-->
          <hr>

          <!--          <li routerLinkActive="active">-->
          <!--            <a href="#" onClick="return false;" class="menu-toggle">-->
          <!--              <i class="fas fa-tachometer-alt"></i>-->
          <!--              <span>Home</span>-->
          <!--            </a>-->
          <!--            <ul class="ml-menu">-->
          <!--              <li routerLinkActive="active">-->
          <!--                <a routerLink="dashboard">Dashboard</a>-->
          <!--              </li>-->
          <!--            </ul>-->
          <!--          </li>-->
          <!--          <li routerLinkActive="active">-->
          <!--            <a href="#" onClick="return false;" class="menu-toggle">-->
          <!--              <i class="fas fa-chart-line"></i>-->
          <!--              <span>Order</span>-->
          <!--            </a>-->
          <!--            <ul class="ml-menu">-->
          <!--              <li routerLinkActive="active" (click)="navPage('agent/order')">-->
          <!--                <a onClick="return false;">Booth Agent Order</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('icustomer/order/register')">-->
          <!--                <a onClick="return false;">Customer Order</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('report/counter/report/per/day')">-->
          <!--                <a onClick="return false;">Daily Counter Sale : Report</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('report/total/sale/per/day')">-->
          <!--                <a onClick="return false;">Daily Counters Sale Summary</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('report/total/sale/per/month')">-->
          <!--                <a onClick="return false;">Monthly Counter Sale Summary</a>-->
          <!--              </li>-->
          <!--            </ul>-->
          <!--          </li>-->
          <!--          <li routerLinkActive="active">-->
          <!--            <a href="#" onClick="return false;" class="menu-toggle">-->
          <!--              <i class="fab fa-hubspot"></i>-->
          <!--              <span>Indent</span>-->
          <!--            </a>-->
          <!--            <ul class="ml-menu">-->
          <!--              <li routerLinkActive="active" (click)="navPage('indent/dashboard')">-->
          <!--                <a onClick="return false;">Prepare Indents</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('old/indent')">-->
          <!--                <a onClick="return false;">Old Indents</a>-->
          <!--              </li>-->
          <!--            </ul>-->
          <!--          </li>-->

          <!--          <li routerLinkActive="active">-->
          <!--            <a href="#" onClick="return false;" class="menu-toggle">-->
          <!--              <i class="fab fa-hubspot"></i>-->
          <!--              <span>Daily Reports</span>-->
          <!--            </a>-->
          <!--            <ul class="ml-menu">-->
          <!--              <li routerLinkActive="active" (click)="navPage('report/route/wise/sale/abstract')">-->
          <!--                <a onClick="return false;">Route Summary</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('report/unique/route/wise/sale/abstract')">-->
          <!--                <a onClick="return false;">Route Abstract</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('report/route/wise/sale/statement')">-->
          <!--                <a onClick="return false;">Route wise Statement</a>-->
          <!--              </li>-->

          <!--              <li routerLinkActive="active" (click)="navPage('report/all/zone/report/per/session')">-->
          <!--                <a onClick="return false;">Zone Summary</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('report/zone/wise/abstract/')">-->
          <!--                <a onClick="return false;">Zone Abstract</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('report/zone/wise/route/abstract')">-->
          <!--                <a onClick="return false;">Zone Routewise Abstract</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('report/daily/sale/zone/wise')">-->
          <!--                <a onClick="return false;">Zone wise Statement</a>-->
          <!--              </li>-->

          <!--              <li routerLinkActive="active" (click)="navPage('report/milk/acknowledgement/report/per/session')">-->
          <!--                <a onClick="return false;">Milk Acknowledgement</a>-->
          <!--              </li>-->

          <!--              <li routerLinkActive="active" (click)="navPage('report/union/wise/summary')">-->
          <!--                <a onClick="return false;">Union wise Summary</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('report/business/type/wise/summary')">-->
          <!--                <a onClick="return false;">BoothType Summary</a>-->
          <!--              </li>-->
          <!--              &lt;!&ndash; <li routerLinkActive="active" (click)="navPage('report/different/type/of/report')">-->
          <!--                <a onClick="return false;">New Report</a>-->
          <!--              </li> &ndash;&gt;-->
          <!--            </ul>-->
          <!--          </li>-->
          <!--          <li routerLinkActive="active">-->
          <!--            <a href="#" onClick="return false;" class="menu-toggle">-->
          <!--              <i class="fab fa-hubspot"></i>-->
          <!--              <span>Monthly Reports</span>-->
          <!--            </a>-->
          <!--            <ul class="ml-menu">-->
          <!--              <li routerLinkActive="active" (click)="navPage('agent/monthly/report')">-->
          <!--                <a onClick="return false;">Agent monthly report</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('report/month/report/agent/monthly/commission')">-->
          <!--                <a onClick="return false;">Commission Report</a>-->
          <!--              </li>-->
          <!--              &lt;!&ndash; <li routerLinkActive="active" (click)="navPage('report/route/gatepass')">-->
          <!--                <a onClick="return false;">Test</a>-->
          <!--              </li> &ndash;&gt;-->
          <!--            </ul>-->
          <!--          </li>-->
          <!--          <hr>-->
          <!--          <li routerLinkActive="active">-->
          <!--            <a href="#" onClick="return false;" class="menu-toggle">-->
          <!--              <i class="fas fa-table"></i>-->
          <!--              <span>Customer Master</span>-->
          <!--            </a>-->
          <!--            <ul class="ml-menu">-->
          <!--              <li routerLinkActive="active" (click)="navPage('booth/table')">-->
          <!--                <a onClick="return false;">Booth</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('agent/table')">-->
          <!--                <a onClick="return false;">Agent</a>-->
          <!--              </li>-->

          <!--              <li routerLinkActive="active" (click)="navPage('icustomer/table')">-->
          <!--                <a onClick="return false;">Card Customer</a>-->
          <!--              </li>-->
          <!--            </ul>-->
          <!--          </li>-->
          <!--          <li routerLinkActive="active">-->
          <!--            <a href="#" onClick="return false;" class="menu-toggle">-->
          <!--              <i class="far fa-images"></i>-->
          <!--              <span>Route Management</span>-->
          <!--            </a>-->
          <!--            <ul class="ml-menu">-->
          <!--              <li routerLinkActive="active" (click)="navPage('route/business/map')">-->
          <!--                <a onClick="return false;" href="#">Route Booth Map</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('route/table')">-->
          <!--                <a onClick="return false;">Create Route</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('route/vehicle/map/table')">-->
          <!--                <a onClick="return false;">Route Vehicle Maps</a>-->
          <!--              </li>-->
          <!--            </ul>-->
          <!--          </li>-->

          <!--          <li routerLinkActive="active">-->
          <!--            <a href="#" onClick="return false;" class="menu-toggle">-->
          <!--              <i class="fas fa-paw"></i>-->
          <!--              <span>Money Management</span>-->
          <!--            </a>-->
          <!--            <ul class="ml-menu">-->
          <!--              <li routerLinkActive="active" (click)="navPage('add/to/wallet')">-->
          <!--                <a onClick="return false;">Add To Wallet</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('cheque/approval')">-->
          <!--                <a onClick="return false;">Cheque Approval</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('agent/transaction')">-->
          <!--                <a onClick="return false;">Agent Transactions</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('customer/transaction')">-->
          <!--                <a onClick="return false;">Customer Transactions</a>-->
          <!--              </li>-->


          <!--            </ul>-->
          <!--          </li>-->

          <!--          <hr>-->
          <!--          <li routerLinkActive="active">-->
          <!--            <a href="#" onClick="return false;" class="menu-toggle">-->
          <!--              <i class="fas fa-mail-bulk"></i>-->
          <!--              <span>Product Masters</span>-->
          <!--            </a>-->
          <!--            <ul class="ml-menu">-->
          <!--              <li routerLinkActive="active" (click)="navPage('product/table')">-->
          <!--                <a onClick="return false;">Product</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('product/unit/table')">-->
          <!--                <a onClick="return false;">Product Unit</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('product/session/available')">-->
          <!--                <a onClick="return false;">Product Mor / Eve Availablity</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('product/price')">-->
          <!--                <a onClick="return false;">Product Price</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('icustomer/discount/price')">-->
          <!--                <a onClick="return false;">ICustomer Product Price</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('booth/agent/commission/trace')">-->
          <!--                <a onClick="return false;">Booth Agent Commission Trace</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('booth/agent/discount/trace')">-->
          <!--                <a onClick="return false;">Booth Agent Discount Trace</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('business/wise/discount/trace')">-->
          <!--                <a onClick="return false;">Business Wise Discount Traces</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('icustomer/typewise/product/discount/trace')">-->
          <!--                <a onClick="return false;">Icustomer Typewise Discount Traces</a>-->
          <!--              </li>-->

          <!--            </ul>-->
          <!--          </li>-->
          <!--          <li routerLinkActive="active">-->
          <!--            <a href="#" onClick="return false;" class="menu-toggle">-->
          <!--              <i class="fab fa-wpforms"></i>-->
          <!--              <span>Vehicle Master</span>-->
          <!--            </a>-->
          <!--            <ul class="ml-menu">-->
          <!--              <li routerLinkActive="active" (click)="navPage('vehicle/type/table')">-->
          <!--                <a ronClick="return false;">Vehicle Type</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('vehicle/transport/table')">-->
          <!--                <a onClick="return false;">Transport Company</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('vehicle/table')">-->
          <!--                <a onClick="return false;">Vehicle</a>-->
          <!--              </li>-->
          <!--            </ul>-->
          <!--            &lt;!&ndash;          <li routerLinkActive="active">&ndash;&gt;-->
          <!--            &lt;!&ndash;            <a routerLink="widget">&ndash;&gt;-->
          <!--            &lt;!&ndash;              <i class="fas fa-braille"></i>&ndash;&gt;-->
          <!--            &lt;!&ndash;              <span>Widgets</span>&ndash;&gt;-->
          <!--            &lt;!&ndash;            </a>&ndash;&gt;-->
          <!--            &lt;!&ndash;          </li>&ndash;&gt;-->
          <!--          <li routerLinkActive="active">-->
          <!--            <a href="#" onClick="return false;" class="menu-toggle">-->
          <!--              <i class="fas fa-drafting-compass"></i>-->
          <!--              <span>Aavin Masters</span>-->
          <!--            </a>-->
          <!--            <ul class="ml-menu">-->
          <!--              <li routerLinkActive="active" (click)="navPage('zone/table')">-->
          <!--                <a onClick="return false;">Zone</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('corporation/zone/table')">-->
          <!--                <a onClick="return false;">Corporation Zone</a>-->
          <!--              </li>-->
          <!--              &lt;!&ndash; <li routerLinkActive="active">-->
          <!--                <a routerLink="booth/type/table">Booth Type</a>-->
          <!--              </li> &ndash;&gt;-->
          <!--              <li routerLinkActive="active" (click)="navPage('employee/table')">-->
          <!--                <a onClick="return false;">Employee</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('union/office/table')">-->
          <!--                <a onClick="return false;">Union Office</a>-->
          <!--              </li>-->
          <!--            </ul>-->
          <!--          </li>-->
          <!--          <li routerLinkActive="active">-->
          <!--            <a href="#" onClick="return false;" class="menu-toggle">-->
          <!--              <i class="fab fa-google-play"></i>-->
          <!--              <span>Area Master</span>-->
          <!--            </a>-->
          <!--            <ul class="ml-menu">-->
          <!--              <li routerLinkActive="active" (click)="navPage('district/table')">-->
          <!--                <a onClick="return false;">District</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('block/table')">-->
          <!--                <a onClick="return false;">Block</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('taluk/table')">-->
          <!--                <a onClick="return false;">Taluk</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('constituency/table')">-->
          <!--                <a onClick="return false;">Constituency</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active" (click)="navPage('ward/table')">-->
          <!--                <a onClick="return false;">Ward</a>-->
          <!--              </li>-->
          <!--              &lt;!&ndash; <li routerLinkActive="active">-->
          <!--                <a routerLink="location/category/table">Location Category</a>-->
          <!--              </li> &ndash;&gt;-->
          <!--            </ul>-->

          <!--          </li>-->




          <!--          <li routerLinkActive="active">-->
          <!--            <a href="#" onClick="return false;" class="menu-toggle">-->
          <!--              <i class="fas fa-id-card"></i>-->
          <!--              <span>Authentication</span>-->
          <!--            </a>-->
          <!--            <ul class="ml-menu">-->
          <!--              <li routerLinkActive="active">-->
          <!--                <a routerLink="authentication/signin">Sign In</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active">-->
          <!--                <a routerLink="authentication/signup">Sign Up</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active">-->
          <!--                <a routerLink="authentication/forgot-password">Forgot Password</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active">-->
          <!--                <a routerLink="authentication/locked">Locked</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active">-->
          <!--                <a routerLink="authentication/page404">404 - Not Found</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active">-->
          <!--                <a routerLink="authentication/page500">500 - Server Error</a>-->
          <!--              </li>-->
          <!--            </ul>-->
          <!--          </li>-->
          <!--          <li routerLinkActive="active">-->
          <!--            <a href="#" onClick="return false;" class="menu-toggle">-->
          <!--              <i class="far fa-file-alt"></i>-->
          <!--              <span>Extra Pages</span>-->
          <!--            </a>-->
          <!--            <ul class="ml-menu">-->
          <!--              <li routerLinkActive="active">-->
          <!--                <a routerLink="extra-pages/profile">Profile</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active">-->
          <!--                <a routerLink="extra-pages/pricing">Pricing</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active">-->
          <!--                <a routerLink="extra-pages/invoice">Invoice</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active">-->
          <!--                <a routerLink="extra-pages/faqs">Faqs</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active">-->
          <!--                <a routerLink="extra-pages/blank">Blank Page</a>-->
          <!--              </li>-->
          <!--            </ul>-->
          <!--          </li>-->
          <!--          <li routerLinkActive="active">-->
          <!--            <a href="#" onClick="return false;" class="menu-toggle">-->
          <!--              <i class="fas fa-globe-americas"></i>-->
          <!--              <span>Maps</span>-->
          <!--            </a>-->
          <!--            <ul class="ml-menu">-->
          <!--              <li routerLinkActive="active">-->
          <!--                <a routerLink="maps/google">Google Map</a>-->
          <!--              </li>-->
          <!--              <li routerLinkActive="active">-->
          <!--                <a routerLink="maps/vector">Vector Map</a>-->
          <!--              </li>-->
          <!--            </ul>-->
          <!--          </li>-->
          <!--          <li routerLinkActive="active">-->
          <!--            <a href="#" onClick="return false;" class="menu-toggle">-->
          <!--              <i class="fas fa-angle-double-down"></i>-->
          <!--              <span>Multi Level Menu</span>-->
          <!--            </a>-->
          <!--            <ul class="ml-menu">-->
          <!--              <li>-->
          <!--                <a href="#" onClick="return false;">-->
          <!--                  <span>Menu Item</span>-->
          <!--                </a>-->
          <!--              </li>-->
          <!--              <li>-->
          <!--                <a href="#" onClick="return false;">-->
          <!--                  <span>Menu Item - 2</span>-->
          <!--                </a>-->
          <!--              </li>-->
          <!--              <li>-->
          <!--                <a href="#" onClick="return false;" class="menu-toggle">-->
          <!--                  <span>Level - 2</span>-->
          <!--                </a>-->
          <!--                <ul class="ml-menu">-->
          <!--                  <li>-->
          <!--                    <a href="#" onClick="return false;">-->
          <!--                      <span>Menu Item</span>-->
          <!--                    </a>-->
          <!--                  </li>-->
          <!--                  <li>-->
          <!--                    <a href="#" onClick="return false;" class="menu-toggle">-->
          <!--                      <span>Level - 3</span>-->
          <!--                    </a>-->
          <!--                    <ul class="ml-menu">-->
          <!--                      <li>-->
          <!--                        <a href="#" onClick="return false;">-->
          <!--                          <span>Level - 4</span>-->
          <!--                        </a>-->
          <!--                      </li>-->
          <!--                    </ul>-->
          <!--                  </li>-->
          <!--                </ul>-->
          <!--              </li>-->
          <!--            </ul>-->
          <!--          </li>-->
        </ul>
      </div>
      <!-- #Menu -->
    </aside>
    <!-- #END# Left Sidebar -->
    <!-- Right Sidebar -->
    <aside id="rightsidebar" class="right-sidebar">
      <ul class="nav nav-tabs tab-nav-right" role="tablist">
        <li role="presentation">
          <a href="#skins" data-toggle="tab" class="active">SKINS</a>
        </li>
        <li role="presentation">
          <a href="#settings" data-toggle="tab">SETTINGS</a>
        </li>
      </ul>
      <div class="tab-content">
        <div role="tabpanel" class="tab-pane in active in active stretchLeft" id="skins">
          <div class="demo-skin">
            <div class="rightSetting">
              <p>GENERAL SETTINGS</p>
              <ul class="setting-list list-unstyled m-t-20">
                <li>
                  <div class="form-check">
                    <div class="form-check m-l-10">
                      <label class="form-check-label">
                        <input class="form-check-input" type="checkbox" value="" checked> Save
                        History
                        <span class="form-check-sign">
                          <span class="check"></span>
                        </span>
                      </label>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="form-check">
                    <div class="form-check m-l-10">
                      <label class="form-check-label">
                        <input class="form-check-input" type="checkbox" value="" checked> Show
                        Status
                        <span class="form-check-sign">
                          <span class="check"></span>
                        </span>
                      </label>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="form-check">
                    <div class="form-check m-l-10">
                      <label class="form-check-label">
                        <input class="form-check-input" type="checkbox" value="" checked> Auto
                        Submit Issue
                        <span class="form-check-sign">
                          <span class="check"></span>
                        </span>
                      </label>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="form-check">
                    <div class="form-check m-l-10">
                      <label class="form-check-label">
                        <input class="form-check-input" type="checkbox" value="" checked> Show
                        Status To All
                        <span class="form-check-sign">
                          <span class="check"></span>
                        </span>
                      </label>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="rightSetting">
              <p>SIDEBAR MENU COLORS</p>
              <button type="button" class="btn btn-sidebar-light btn-border-radius p-l-20 p-r-20">Light</button>
              <button type="button"
                class="btn btn-sidebar-dark btn-default btn-border-radius p-l-20 p-r-20">Dark</button>
            </div>
            <div class="rightSetting">
              <p>THEME COLORS</p>
              <button type="button" class="btn btn-theme-light btn-border-radius p-l-20 p-r-20">Light</button>
              <button type="button" class="btn btn-theme-dark btn-default btn-border-radius p-l-20 p-r-20">Dark</button>
            </div>
            <div class="rightSetting">
              <p>SKINS</p>
              <ul class="demo-choose-skin choose-theme list-unstyled">
                <li data-theme="black" class="actived">
                  <div class="black-theme"></div>
                </li>
                <li data-theme="white">
                  <div class="white-theme white-theme-border"></div>
                </li>
                <li data-theme="purple">
                  <div class="purple-theme"></div>
                </li>
                <li data-theme="blue">
                  <div class="blue-theme"></div>
                </li>
                <li data-theme="cyan">
                  <div class="cyan-theme"></div>
                </li>
                <li data-theme="green">
                  <div class="green-theme"></div>
                </li>
                <li data-theme="orange">
                  <div class="orange-theme"></div>
                </li>
              </ul>
            </div>
            <div class="rightSetting">
              <p>Disk Space</p>
              <div class="sidebar-progress">
                <div class="progress m-t-20">
                  <div class="progress-bar l-bg-cyan shadow-style width-per-45" role="progressbar" aria-valuenow="45"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <span class="progress-description">
                  <small>26% remaining</small>
                </span>
              </div>
            </div>
            <div class="rightSetting">
              <p>Server Load</p>
              <div class="sidebar-progress">
                <div class="progress m-t-20">
                  <div class="progress-bar l-bg-orange shadow-style width-per-63" role="progressbar" aria-valuenow="63"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <span class="progress-description">
                  <small>Highly Loaded</small>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div role="tabpanel" class="tab-pane stretchRight" id="settings">
          <div class="demo-settings">
            <p>GENERAL SETTINGS</p>
            <ul class="setting-list">
              <li>
                <span>Report Panel Usage</span>
                <div class="switch">
                  <label>
                    <input type="checkbox" checked>
                    <span class="lever switch-col-green"></span>
                  </label>
                </div>
              </li>
              <li>
                <span>Email Redirect</span>
                <div class="switch">
                  <label>
                    <input type="checkbox">
                    <span class="lever switch-col-blue"></span>
                  </label>
                </div>
              </li>
            </ul>
            <p>SYSTEM SETTINGS</p>
            <ul class="setting-list">
              <li>
                <span>Notifications</span>
                <div class="switch">
                  <label>
                    <input type="checkbox" checked>
                    <span class="lever switch-col-purple"></span>
                  </label>
                </div>
              </li>
              <li>
                <span>Auto Updates</span>
                <div class="switch">
                  <label>
                    <input type="checkbox" checked>
                    <span class="lever switch-col-cyan"></span>
                  </label>
                </div>
              </li>
            </ul>
            <p>ACCOUNT SETTINGS</p>
            <ul class="setting-list">
              <li>
                <span>Offline</span>
                <div class="switch">
                  <label>
                    <input type="checkbox" checked>
                    <span class="lever switch-col-red"></span>
                  </label>
                </div>
              </li>
              <li>
                <span>Location Permission</span>
                <div class="switch">
                  <label>
                    <input type="checkbox">
                    <span class="lever switch-col-lime"></span>
                  </label>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </aside>
    <!-- #END# Right Sidebar -->
  </div>
</div>
<router-outlet></router-outlet>
